import React from 'react';
import css from './css.module.less';
//import { useParams } from 'react-router-dom';
// import {
//   getCustomersInSalesChannel,
//   getTagsInSalesChannel,
// } from 'src/request/customer';
import Query, { EnumQueryType } from 'src/constrains/Query1';
import { useQueries } from '@/src/tools/hooks/listPageHooks';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { SizeFittingTable, ModalFooter } from 'src/components/Antd';
import { get } from 'lodash';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { generalSort } from 'src/tools/helper';
import { getDbRelated } from 'src/request/voucher';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { getCustomerSummaries } from 'src/request/voucher';
import {
  CustomerSummary,
  FetchCustomerSummariesParams,
} from 'src/types/customer';

const convertQuery = (filter) => {
  const re: any = {};
  if (filter.customerTags) {
    if (filter.customerTags.length > 0) {
      re.customerTags = filter.customerTags.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const filterList = (taggedList, { getI18n }) => {
  return [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.tags') },
      keyWord: 'customerTags',
      options: taggedList.map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
      searchable: true,
    },
  ];
};

const CustomerSelectionNoPagination = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //const { uuid }: any = useParams();
  const constants = { firstRow: 0, countPerPage: 999 };
  const { selected, onCancel, onConfirm, dbUuid, rowSelectionType, okText } =
    props;

  const currentSelected = (selected || []).map((i) => i.uuid);
  // const [selectedCustomers, setSelectedCustomers] =
  //   React.useState(currentSelected);
  const [allCustomers, setAllCustomers] = React.useState<CustomerSummary[]>(
    currentSelected || [],
  );
  const [selectedRowKeys, setSelectedRowKeys] = React.useState();
  const [tags, setTags] = React.useState([]);
  const [loadingCustomers, setLoadingCustomers] = React.useState(false);

  // const [loaded, setLoaded] = React.useState(false);

  const col = [
    {
      minWidth: 150,
      className: css.modalRow,
      title: getI18n('general.customerID'),
      key: 'uuid',
      default: true,
      sorter: (a, b) => {
        const name1 = a.uuid || '';
        const name2 = b.uuid || '';
        return generalSort(name1, name2);
      },
      childGenerate: (a, record, index) => {
        const name = get(record, 'uuid');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      sorter: (a, b) => {
        const name1 = a.fullName || '';
        const name2 = b.fullName || '';
        return generalSort(name1, name2);
      },
      title: getI18n('general.customer.fullName'),
      className: css.modalRow,
      key: 'fullName',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'fullName');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.mobileNumber'),
      className: css.modalRow,
      key: 'areaCode',
      default: true,
      childGenerate: (a, record, index) => {
        const areaCode = get(record, 'areaCode', '');
        const number = get(record, 'mobile', '');
        const display = `${areaCode || ''} ${number || ''}`;
        return (
          <NoWrapContainer>
            <Tooltip title={display}>{display}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.email'),
      className: css.modalRow,
      key: 'email',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'email');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      title: getI18n('general.remarks'),
      minWidth: 150,
      className: css.modalRow,
      key: 'remarks',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'remarks');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
  ];

  React.useEffect(() => {
    if (dbUuid) {
      getDbRelated(constants, {
        params: { customerDatabaseUuid: dbUuid },
      }).then((res) => {
        const { customerTags } = res;
        setTags(customerTags || []);
      });
    }
  }, [dbUuid]);

  React.useEffect(() => {
    if (dbUuid) {
      setLoadingCustomers(true);
      const initialParams: FetchCustomerSummariesParams = {
        ...constants,
        countPerPage: 99999,
      };
      getCustomerSummaries(dbUuid, initialParams)
        .then((payload) => {
          setAllCustomers(payload.results || []);
        })
        .catch((error) => {
          console.error('Error fetching initial customers:', error);
          setAllCustomers([]);
        })
        .finally(() => {
          setLoadingCustomers(false);
        });
    }
  }, [dbUuid]);

  const onSelectChange = (value) => {
    setSelectedRowKeys(value);
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
    type: rowSelectionType,
  };

  const { queryProps, search } = useQueries(
    filterList(tags || [], { getI18n }),
    [],
    convertQuery,
  );

  useAfterDidMountEffect(() => {
    const { searchText, customerTags } = search || {};

    if (dbUuid) {
      setLoadingCustomers(true);
      const params: FetchCustomerSummariesParams = {
        searchTextList: searchText ? searchText : undefined,
        customerTags,
        firstRow: 0,
        countPerPage: 99999,
      };
      getCustomerSummaries(dbUuid, params)
        .then((payload) => {
          setAllCustomers(payload.results || []);
        })
        .catch((error) => {
          console.error('Error fetching filtered customers:', error);
          setAllCustomers([]);
        })
        .finally(() => {
          setLoadingCustomers(false);
        });
    }
  }, [search, dbUuid]);

  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  const handleOnConfirm = () => {
    const customers = (selectedRowKeys || []).map((i) => {
      const customer = allCustomers.find((c) => c.uuid === i);
      return customer;
    });
    if (onConfirm) {
      onConfirm(customers);
    }
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <div className={css.queryContainer}>
          <Query
            onSearchChange={handleOnSearchChange}
            onFilterChange={handleOnFilterChange}
            onTagClose={handleOnSearchClose}
            filters={queryProps.filters || []}
            sortList={queryProps.sortList || []}
            data={queryProps.searchConditions || []}
          />
        </div>
        <SizeFittingTable
          className={css.modalTableBody}
          id='SalesChannelDiscountCustomerModalTable'
          dataSource={allCustomers}
          rowSelection={rowSelection}
          pagination={false}
          columns={col}
          rowKey={'uuid'}
          scroll={{ x: 'max-content', y: 392 }}
          loading={loadingCustomers}
        />
      </div>{' '}
      <ModalFooter
        frontCountTip={`${(selectedRowKeys || []).length} ${getI18n(
          'general.itemsselected',
        )}`}
        okText={okText || getI18n('general.confirm')}
        cancelText={getI18n('general.cancel')}
        // okClassName={css.okBtn}
        onOk={handleOnConfirm}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};

export default CustomerSelectionNoPagination;
